import React, { ReactNode } from "react";

import "./CommonAdvancedViewGrid.scss";

export const CommonAdvancedViewGrid = ({
  children,
}: {
  children: ReactNode;
}) => {
  return <div className="common-advanced-view-grid">{children}</div>;
};
